import React from 'react';
import { HStack, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

// Columnas de la grilla de EXÁMENES individuales (Módulo 7).
// Requerimiento cliente:
//   Columnas: ID examen | Estudio | Plan | Materia | Fecha + hora
//   Acciones: ACTA | MESA EXAMINADORA
//
// La grilla consume GET /exam/schedule. El mapeo de raw SQL (snake_case)
// al shape { id, study, studyPlan, subject, examDateTime } se hace en
// views/admin/examList/index.jsx antes de pasar los datos a la grilla.

const ExamActions = ({ row }) => {
  const navigate = useNavigate();
  const id = row?.original?.id;
  return (
    <HStack spacing={2} onClick={(e) => e.stopPropagation()}>
      <Button
        size="xs"
        colorScheme="purple"
        variant="outline"
        onClick={() => navigate(`/admin/exams/${id}/acta`)}
      >
        ACTA
      </Button>
      <Button
        size="xs"
        colorScheme="teal"
        variant="outline"
        onClick={() => navigate(`/admin/exams/${id}/tribunal`)}
      >
        MESA EXAMINADORA
      </Button>
    </HStack>
  );
};

export const columnsDataStudies = [
  {
    Header: 'ID EXAMEN',
    accessor: 'id',
  },
  {
    Header: 'ESTUDIO',
    accessor: 'estudio',
    computedValue: (rowData) =>
      rowData?.study?.description || rowData?.estudio || '-',
  },
  {
    Header: 'PLAN',
    accessor: 'plan',
    computedValue: (rowData) =>
      rowData?.studyPlan?.description || rowData?.plan || '-',
  },
  {
    Header: 'MATERIA',
    accessor: 'materia',
    computedValue: (rowData) =>
      rowData?.subject?.description || rowData?.materia || '-',
  },
  {
    Header: 'FECHA + HORA',
    accessor: 'examenDate',
    computedValue: (rowData) => {
      const raw = rowData?.examDateTime || rowData?.examenDate;
      if (!raw) return '-';
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return String(raw);
      return `${d.toLocaleDateString('es-ES')} ${d.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
      })}`;
    },
  },
  {
    Header: 'ACCIONES',
    accessor: 'examActions',
    Cell: (info) => <ExamActions row={info.row} />,
  },
];
